import React from 'react';

function RangeSlider(props) {
    const step = Number.parseFloat(100 / (props.elems.length - 1)).toFixed(2);
    const defaultValue = props.defaultValue ? props.defaultValue * step : 0;

    function handleOnChange(e) {
        const v = e.target.value;
        const index = Math.floor(v / step);
        props.onChange(index);
    }

    return (
        <div className="d-flex flex-column input-range-container">
            <input type="range" min="0" max="100" step={step} onChange={handleOnChange} defaultValue={defaultValue} />
            <div className="d-flex justify-content-between marks-container">
                {props.elems.map((el, i) =>
                    <span key={i}>{el}</span>
                )}
            </div>
        </div>
    );
}

export default RangeSlider;